/* TODO: t() */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { Component } from 'react';
import { View, StyleSheet } from 'react-native';
import {
  Button,
  Form,
  FormField,
  TextInputPassword,
  SubmitButton,
  Alert,
} from '../../../src/components/uiold';
import { themeColors } from '../uiold/Constants';
import LoadingIndicator from '../uiold/LoadingIndicator';
import Label from '../uiold/Label';
import { postJSON } from '../../support/Fetch';

import { showSuccess } from '../App/AppAlert';
import AdminModal from './AdminModal';

type Props = {
  onHide: () => void;
};

type State = {
  currentPassword: string;
  newPassword: string;
  confirmPassword: string;
  isLoading: boolean;
  error: string | null | undefined;
};

class ChangePasswordModal extends Component<Props, State> {
  state: State = {
    currentPassword: '',
    newPassword: '',
    confirmPassword: '',
    isLoading: false,
    error: null,
  };

  render() {
    let {
      currentPassword,
      newPassword,
      confirmPassword,
      isLoading,
    } = this.state;
    return (
      <AdminModal
        onClose={this.props.onHide}
        style={styles.modal}
        title="Change Password"
        noBodyDefault
      >
        {isLoading ? (
          <LoadingIndicator />
        ) : (
          <Form onSubmit={this._onSubmit}>
            <AdminModal.Body>
              {this._renderError()}
              <FormField
                render={(id) => (
                  <View style={styles.formField}>
                    <Label style={styles.textLabel} htmlFor={id}>
                      Current Password
                    </Label>
                    <TextInputPassword
                      id={id}
                      autoFocus
                      style={styles.textInput}
                      value={currentPassword}
                      skipFirstCheck
                      errorMessage="Please enter your current password."
                      checkPassword={(value: string) => !!value}
                      onChangeText={(value: string) =>
                        this._onFieldChange('currentPassword', value)
                      }
                    />
                  </View>
                )}
              />
              <FormField
                render={(id) => (
                  <View style={styles.formField}>
                    <Label style={styles.textLabel} htmlFor={id}>
                      New Password
                    </Label>
                    <TextInputPassword
                      id={id}
                      style={styles.textInput}
                      value={newPassword}
                      skipFirstCheck
                      errorMessage="Minimum length 8; must include uppercase, lowercase and number."
                      onChangeText={(value: string) =>
                        this._onFieldChange('newPassword', value)
                      }
                    />
                  </View>
                )}
              />
              <FormField
                render={(id) => (
                  <View style={styles.formField}>
                    <Label style={styles.textLabel} htmlFor={id}>
                      Confirm New Password
                    </Label>
                    <TextInputPassword
                      id={id}
                      style={styles.textInput}
                      value={confirmPassword}
                      skipFirstCheck
                      checkPassword={(value: string) => newPassword === value}
                      errorMessage="Password does not match."
                      onChangeText={(value: string) =>
                        this._onFieldChange('confirmPassword', value)
                      }
                    />
                  </View>
                )}
              />
            </AdminModal.Body>
            <AdminModal.Footer>
              <Button
                title="Cancel"
                onPress={() => this.props.onHide()}
                style={{ backgroundColor: 'none', borderWidth: 0 }}
              />
              <SubmitButton title="Save" />
            </AdminModal.Footer>
          </Form>
        )}
      </AdminModal>
    );
  }

  _onFieldChange = (fieldName: string, value: string) => {
    this.setState({ [fieldName]: value } as any);
  };

  _renderError = () => {
    if (!this.state.error) {
      return;
    }
    return (
      <Alert
        type="error"
        onDismiss={this._errorDismiss}
        text={this.state.error}
      />
    );
  };

  _errorDismiss = () => {
    this.setState({ error: null });
  };

  _onSubmit = () => {
    let errorText = '';
    let { currentPassword, newPassword, confirmPassword } = this.state;
    if (currentPassword.length === 0) {
      errorText = 'Please enter your current password.';
    } else if (newPassword.length === 0) {
      errorText = 'Please enter a new password.';
    } else if (confirmPassword.length === 0) {
      errorText = 'Please re-enter your new password.';
    } else if (newPassword !== confirmPassword) {
      errorText = 'New password does not match.';
    }
    if (errorText) {
      this.setState({ error: errorText });
      return;
    }
    this.setState({ isLoading: true });
    postJSON(
      '/api/vendor-account/password',
      { current: currentPassword, password: newPassword },
      (error, data) => {
        if (data && typeof data.error === 'string') {
          this.setState({ isLoading: false, error: data.error });
        } else if (error) {
          this.setState({ isLoading: false, error: error.message });
        } else if (data.success === true) {
          this.props.onHide();
          showSuccess('Password Changed Successfully.');
        } else {
          this.setState({ isLoading: false, error: 'Unknown error.' });
        }
      },
    );
  };
}

let styles = StyleSheet.create({
  modal: {
    width: 450,
  },
  textLabel: {
    color: themeColors.darkGrey,
    marginTop: 10,
  },
  textInput: {
    marginVertical: 5,
    backgroundColor: themeColors.lightGrey,
  },
  formField: {
    paddingBottom: 30,
  },
});

export default ChangePasswordModal;
